import { __ } from '@wordpress/i18n';
import { Select } from '../components/select';
import  RadioControl  from '../components/radio-control';
import clsx from 'clsx';
import {
	ValidatedTextInput,
	CheckboxControl,
} from '@woocommerce/blocks-components';
import { useRef } from 'react';
import customValidationHandler  from '../components/custom-validation-handler';
import ParagraphField from '../components/paragraph-field';
import HeadingField from '../components/heading-field';
import TextareaField from '../components/textarea';

const editFields = ( {field} ) => {

	const { id, label, type, value, placeholder, required, options, title, validate, enabled, cssclass, property_set } = field;
	const { default : defaultValue , checked } = property_set;
	const fieldProps = createFieldProps( field );
	const fieldsRef = useRef( {} );

	if (!enabled || enabled === '0') {
		return null;
	}

	const handleChange = (newValue) => {
       
    };

	if (type === 'checkbox') {

		return (
			<CheckboxControl
				key={id}
				checked={value}
				onChange={handleChange}
				{...createCheckboxFieldProps(fieldProps)}
				className={clsx(
                    cssclass?.split(',').map(className => className.trim())
                )}
				required={required}
			/>
		);

	}

		if ( type === 'select' && field.options) {
			
			return (
				<Select
					key={ id }
					{ ...fieldProps }
					label = {title || ''}
					className={clsx(
						cssclass?.split(',').map(className => className.trim()),
						'wc-block-components-select-input',
						`wc-block-components-select-input-${id}`.replaceAll('/', '-')
					)}
					value={ value }
					onChange={handleChange}
					options={ fieldProps.options }
					required={ required }
					errorMessage={fieldProps.errorMessage || undefined}
					placeholder={placeholder|| null}
				/>
			);
		}

		if ( type === 'radio' ) {

			return (	
				<RadioControl
					{ ...fieldProps }
					selected={ value }
					onChange={handleChange}
					options={fieldProps.options}
					disabled={false}
					highlightChecked={true}
					title={title || ''}
					className={clsx(
						cssclass?.split(',').map(className => className.trim())
					)}
					required={required}
				/>
			);
		}


	if ( type === 'paragraph' ) {
        return <ParagraphField field={ field } />;
    }

    if ( type === 'heading' ) {
        return <HeadingField field={ field } />;
    }

    if ( type === 'textarea' ) {
        return ( <TextareaField field={field} value={value} onChange={handleChange} required={required}/>  );
    }

		return (
			<ValidatedTextInput
				key={ id }
				ref={ ( el ) =>
					( fieldsRef.current[ id ] = el )
				}
				{ ...fieldProps }
				type={ type }
				value={ value }
				onChange={handleChange}
				customFormatter={ ( value  ) => {
					if ( field.type === 'postcode' ) {
						return value.trimStart().toUpperCase();
					}
					return value;
				} }
				customValidation={ ( inputObject ) =>
					customValidationHandler(
						inputObject,
						validate,
					)
				}
				className={clsx(
                    cssclass?.split(',').map(className => className.trim())
                )}
			/>
	);
};

export default editFields;

const createFieldProps = (field) => ({
	id: `section_one-${field?.id}`.replaceAll('/', '-'),
	errorId: `section_${field?.id}`,
	label: field?.title,
	autoCapitalize: field?.autocapitalize,
	autoComplete: field?.autocomplete,
	errorMessage: field?.errorMessage,
	required: field?.required,
	placeholder: field?.placeholder,
	className: `wc-block-components-address-form__${field?.id}`.replaceAll('/', '-'),
	options: field?.options
		? Object.values(field.options).map((option) => ({
				value: option.key,
				label: option.text,
		  }))
		: [],
	...field?.attributes,
});

const createCheckboxFieldProps = (fieldProps) => {
	const {
		errorId,
		errorMessage,
		autoCapitalize,
		autoComplete,
		placeholder,
		...rest
	} = fieldProps;
	return rest;
};

